var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadmusDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00;}\n\t.st1{opacity:0.4;fill:url(#SVGID_1_);enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,10.5c0.1,0.2,0.1,0.4-0.1,0.5l-14.6,8.4c-0.1,0.1-0.2,0.1-0.3,0l-2.2-1.3C21.9,15.3,15.8,17,13,21.8 c-1.3,2.3-1.6,4.9-1.1,7.3c0,0.1,0,0.3-0.2,0.4l-5.3,3.1c-0.3,0.2-0.2,0.6,0.2,0.6h7.2c0.1,0,0.2,0,0.3,0.1c0.7,0.9,1.6,1.6,2.6,2.2 l8,4.6c4.5,2.6,9.6,3.2,14.2,2c0.3-0.1,0.6,0.4,0.3,0.6C35,46,29.8,48,24,48C10.7,48,0,37.3,0,24S10.7,0,24,0 C32.2,0,39.5,4.2,43.8,10.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.5057,
    y1: 43.3313,
    x2: 36.5057,
    y2: 24.6647,
    gradientTransform: "matrix(1 0 0 -1 0 50)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.7,4.3c2.5,1.7,4.6,3.9,6.3,6.5l-15,8.7l0,0L37.7,4.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadmusDark);
export default __webpack_public_path__ + "static/media/cadmus_dark.bf17c82ee4cca85448fc4a81ffe10258.svg";
export { ForwardRef as ReactComponent };